import { render, staticRenderFns } from "./ModalPriceChange.vue?vue&type=template&id=d3a36924&scoped=true"
import script from "./ModalPriceChange.vue?vue&type=script&lang=js"
export * from "./ModalPriceChange.vue?vue&type=script&lang=js"
import style0 from "./ModalPriceChange.vue?vue&type=style&index=0&id=d3a36924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a36924",
  null
  
)

export default component.exports